// Investment Banking
import ardeaLogo from '@/Framework/assets/customers/ardea.png';
import berkshireLogo from '@/Framework/assets/customers/berkshire.png';
import barclaysLogo from '@/Framework/assets/customers/barclays.png';
import bnpLogo from '@/Framework/assets/customers/bnp.png';
import citiLogo from '@/Framework/assets/customers/citi.png';
import cantorLogo from '@/Framework/assets/customers/cantor.png';
import cowenLogo from '@/Framework/assets/customers/cowen.png';
import goldmanSachsLogo from '@/Framework/assets/customers/goldmanSachs.png';
import guggenheimLogo from '@/Framework/assets/customers/guggenheim.png';
import houlihanLokeyLogo from '@/Framework/assets/customers/houlihanLokey.png';
import jpmorganLogo from '@/Framework/assets/customers/jpmorgan.png';
import jefferiesLogo from '@/Framework/assets/customers/jefferies.png';
import keyBankLogo from '@/Framework/assets/customers/keyBank.png';
import lazardLogo from '@/Framework/assets/customers/lazard.png';
import lincolnLogo from '@/Framework/assets/customers/lincoln.png';
import mizuhoLogo from '@/Framework/assets/customers/mizuho.png';
import moelisLogo from '@/Framework/assets/customers/moelis.png';
import mufgLogo from '@/Framework/assets/customers/mufg.png';
import morganStanleyLogo from '@/Framework/assets/customers/morganStanley.png';
import nomuraLogo from '@/Framework/assets/customers/nomura.png';
import CIBC from '@/Framework/assets/customers/CIBC.png';
import atlasSP from '@/Framework/assets/customers/atlasSP.png';
import piperSandlerLogo from '@/Framework/assets/customers/piperSandler.png';
import pjtLogo from '@/Framework/assets/customers/pjt.png';
import raymondJamesLogo from '@/Framework/assets/customers/raymondJames.png';
import rothschildLogo from '@/Framework/assets/customers/rothschild.png';
import scotiaBankLogo from '@/Framework/assets/customers/scotiaBank.png';
import peiLogo from '@/Framework/assets/customers/pei.png';
import wellsFargoLogo from '@/Framework/assets/customers/wellsFargo.png';
import williamBlairLogo from '@/Framework/assets/customers/williamBlair.png';
// Private Equity & Venture Capital
import blackstoneLogo from '@/Framework/assets/customers/blackstone.png';
import beachPointLogo from '@/Framework/assets/customers/beachPoint.png';
import fflPartnersLogo from '@/Framework/assets/customers/fflPartners.png';
import higLogo from '@/Framework/assets/customers/hig.png';
import vLogo from '@/Framework/assets/customers/v.png';
import kkrLogo from '@/Framework/assets/customers/kkr.png';
import lorientCapitalLogo from '@/Framework/assets/customers/lorientCapital.png';
import manhattanVenturePartnersLogo from '@/Framework/assets/customers/manhattanVenturePartners.png';
import pagayaLogo from '@/Framework/assets/customers/pagaya.png';
import patonaEquityLogo from '@/Framework/assets/customers/patonaEquity.png';
import reverenceCapitalPartnersLogo from '@/Framework/assets/customers/reverenceCapitalPartners.png';
import shoreViewLogo from '@/Framework/assets/customers/shoreView.png';
import skysailAdvisorsLogo from '@/Framework/assets/customers/skysailAdvisors.png';
import quilvestLogo from '@/Framework/assets/customers/quilvest.png';
import upper90Logo from '@/Framework/assets/customers/upper90.png';
// Corporate
import allyLogo from '@/Framework/assets/customers/ally.png';
import arbysLogo from '@/Framework/assets/customers/arbys.png';
import californiaRepublicBankLogo from '@/Framework/assets/customers/californiaRepublicBank.png';
import cerberusLogo from '@/Framework/assets/customers/cerberus.png';
import cnhiLogo from '@/Framework/assets/customers/cnhi.png';
import coxLogo from '@/Framework/assets/customers/cox.png';
import dellLogo from '@/Framework/assets/customers/dell.png';
import dineEquityLogo from '@/Framework/assets/customers/dineEquity.svg';
import dominosLogo from '@/Framework/assets/customers/dominos.png';
import drivenBrandsLogo from '@/Framework/assets/customers/drivenBrands.png';
import driveTimeLogo from '@/Framework/assets/customers/driveTime.png';
import dunkinDonutsLogo from '@/Framework/assets/customers/dunkinDonuts.png';
import fannieMaeLogo from '@/Framework/assets/customers/fannieMae.png';
import freddieMacLogo from '@/Framework/assets/customers/freddieMac.png';
import harleyDavidsonLogo from '@/Framework/assets/customers/harleyDavidson.png';
import hertzLogo from '@/Framework/assets/customers/hertz.png';
import hondaLogo from '@/Framework/assets/customers/honda.png';
import hootersLogo from '@/Framework/assets/customers/hooters.png';
import hyundaiCapitalLogo from '@/Framework/assets/customers/hyundaiCapital.png';
import miramaxLogo from '@/Framework/assets/customers/miramax.png';
import nationStarLogo from '@/Framework/assets/customers/nationStar.png';
import navientLogo from '@/Framework/assets/customers/navient.png';
import sallieMaeLogo from '@/Framework/assets/customers/sallieMae.png';
import sbaLogo from '@/Framework/assets/customers/sba.png';
import sofiLogo from '@/Framework/assets/customers/sofi.png';
import sonicLogo from '@/Framework/assets/customers/sonic.png';
import sunTrustLogo from '@/Framework/assets/customers/sunTrust.png';
import teslaLogo from '@/Framework/assets/customers/tesla.png';
import verizonLogo from '@/Framework/assets/customers/verizon.png';
import yumLogo from '@/Framework/assets/customers/yum.png';

export const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  initialSlide: 0,
  rows: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 5,
      },
    },
  ],
};

export const privateEquityAndVentureCapitalSliderSettings = {
  ...sliderSettings,
  slidesToShow: 4,
  rows: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 5,
      },
    },
  ],
};

export const defaultTab = 'investmentBanking';

export const tabsMapping = [
  {
    label: 'Investment Banking',
    value: 'investmentBanking',
  },
  {
    label: 'Private Equity & Venture Capital',
    value: 'privateEquityAndVentureCapital',
  },
  {
    label: 'Corporate',
    value: 'corporate',
  },
];

export const tabsContent = {
  investmentBanking: {
    sliderSettings,
    logosConfig: [
      {
        src: ardeaLogo,
        title: 'Ardea',
      },
      {
        src: CIBC,
        title: 'CIBC',
      },
      {
        src: jpmorganLogo,
        title: 'J.P.Morgan',
      },
      {
        src: moelisLogo,
        title: 'Moelis & Company',
      },
      {
        src: pjtLogo,
        title: 'PJT',
      },
      {
        src: atlasSP,
        title: 'Atlas SP',
      },
      {
        src: citiLogo,
        title: 'citi',
      },
      {
        src: jefferiesLogo,
        title: 'Jefferies',
      },
      {
        src: morganStanleyLogo,
        title: 'Morgan Stanley',
      },
      {
        src: raymondJamesLogo,
        title: 'Raymond James',
      },
      {
        src: barclaysLogo,
        title: 'Barclays',
      },
      {
        src: cowenLogo,
        title: 'Cowen Group',
      },
      {
        src: keyBankLogo,
        title: 'KeyBank',
      },
      {
        src: mufgLogo,
        title: 'Mufg',
      },
      {
        src: rothschildLogo,
        title: 'Rothschild & Co',
      },
      {
        src: berkshireLogo,
        title: 'Berkshire',
      },
      {
        src: goldmanSachsLogo,
        title: 'Goldman Sachs',
      },
      {
        src: lazardLogo,
        title: 'Lazard',
      },
      {
        src: nomuraLogo,
        title: 'Nomura',
      },
      {
        src: scotiaBankLogo,
        title: 'Scotiabank',
      },
      {
        src: bnpLogo,
        title: 'BNP Paribas',
      },
      {
        src: guggenheimLogo,
        title: 'Guggenheim',
      },
      {
        src: lincolnLogo,
        title: 'Lincoln International',
      },
      {
        src: peiLogo,
        title: 'PEI',
      },
      {
        src: wellsFargoLogo,
        title: 'Wells Fargo',
      },
      {
        src: cantorLogo,
        title: 'Cantor',
      },
      {
        src: houlihanLokeyLogo,
        title: 'Houlihan Lokey',
      },
      {
        src: mizuhoLogo,
        title: 'Mizuho',
      },
      {
        src: piperSandlerLogo,
        title: 'Piper Sandler',
      },
      {
        src: williamBlairLogo,
        title: 'William Blair',
      },
    ],
  },
  privateEquityAndVentureCapital: {
    sliderSettings: privateEquityAndVentureCapitalSliderSettings,
    logosConfig: [
      {
        src: blackstoneLogo,
        title: 'Blackstone',
      },
      {
        src: higLogo,
        title: 'H.I.G',
      },
      {
        src: manhattanVenturePartnersLogo,
        title: 'Manhattan Venture Partners',
      },
      {
        src: shoreViewLogo,
        title: 'Shore View',
      },
      {
        src: beachPointLogo,
        title: 'Beach Point',
      },
      {
        src: vLogo,
        title: 'Jadian Capital',
      },
      {
        src: pagayaLogo,
        title: 'Pagaya',
      },
      {
        src: skysailAdvisorsLogo,
        title: 'Skysail Advisors',
      },
      {
        src: cerberusLogo,
        title: 'Cerberus',
      },
      {
        src: kkrLogo,
        title: 'KKR',
      },
      {
        src: patonaEquityLogo,
        title: 'Patona Equity',
      },
      {
        src: quilvestLogo,
        title: 'Quilvest',
      },
      {
        src: fflPartnersLogo,
        title: 'FFL Partners',
      },
      {
        src: lorientCapitalLogo,
        title: 'Lorient Capital',
      },
      {
        src: reverenceCapitalPartnersLogo,
        title: 'Lorient Capital',
      },
      {
        src: upper90Logo,
        title: 'Upper 90',
      },
    ],
  },
  corporate: {
    sliderSettings,
    logosConfig: [
      {
        src: allyLogo,
        title: 'Ally',
      },
      {
        src: dellLogo,
        title: 'DELL',
      },
      {
        src: fannieMaeLogo,
        title: 'Fannie Mae',
      },
      {
        src: hyundaiCapitalLogo,
        title: 'Hyundai Capital',
      },
      {
        src: sofiLogo,
        title: 'SoFi',
      },
      {
        src: arbysLogo,
        title: 'Arbys',
      },
      {
        src: dineEquityLogo,
        title: 'dineEquity',
      },
      {
        src: freddieMacLogo,
        title: 'Freddie Mac',
      },
      {
        src: miramaxLogo,
        title: 'Miramax',
      },
      {
        src: sonicLogo,
        title: 'Sonic',
      },
      {
        src: californiaRepublicBankLogo,
        title: 'California Republic Bank',
      },
      {
        src: dominosLogo,
        title: 'Domino\'s',
      },
      {
        src: harleyDavidsonLogo,
        title: 'Harley-Davidson',
      },
      {
        src: nationStarLogo,
        title: 'Nationstar',
      },
      {
        src: sunTrustLogo,
        title: 'SunTrust',
      },
      {
        src: cerberusLogo,
        title: 'Cerberus Capital Management L.P.',
      },
      {
        src: drivenBrandsLogo,
        title: 'DrivenBrands',
      },
      {
        src: hertzLogo,
        title: 'Hertz',
      },
      {
        src: navientLogo,
        title: 'NAVIENT',
      },
      {
        src: teslaLogo,
        title: 'Tesla',
      },
      {
        src: cnhiLogo,
        title: 'CNHI Industrial',
      },
      {
        src: driveTimeLogo,
        title: 'DriveTime',
      },
      {
        src: hondaLogo,
        title: 'Honda',
      },
      {
        src: sallieMaeLogo,
        title: 'SallieMae',
      },
      {
        src: verizonLogo,
        title: 'Verizon',
      },
      {
        src: coxLogo,
        title: 'COX',
      },
      {
        src: dunkinDonutsLogo,
        title: 'Dunkin Donuts',
      },
      {
        src: hootersLogo,
        title: 'Hooters',
      },
      {
        src: sbaLogo,
        title: 'SBA',
      },
      {
        src: yumLogo,
        title: 'Yum!',
      },
    ],
  },
};
